import logo from './img/logo.png';
import m1 from './img/Home/m1.webp';
import m2 from './img/Home/m2.webp';
import m3 from './img/Home/m3.webp';

import up1 from './img/Home/up1.webp';
import up2 from './img/Home/up2.webp';
import up3 from './img/Home/up3.webp';

import a1 from './img/Home/m1m.webp';
import a2 from './img/Home/m2m.webp';
import a3 from './img/Home/m3m.webp';
import a4 from './img/Home/MainBlockMobile/m1.webp';
import a5 from './img/Home/MainBlockMobile/m2.webp';
import a6 from './img/Home/MainBlockMobile/m3.webp';

export const images = [
    logo,m1,m2,m3,up1,up2,up3,a1,a2,a3,a4,a5,a6
];